import keys from 'lodash/keys'
import reduce from 'lodash/reduce'

interface FrontPageParams {
  data: any
  condition?: any,
  next?: number,
  size?: number,
  matchMethod?: string
}

const matchMethods = ['fuzzy', 'exact']

export default function useFrontPage({
  data = [],
  condition = {},
  next = 1,
  size = 10,
  // [fuzzy|exact]
  matchMethod = 'exact'
}: FrontPageParams) {
  if (!data?.length) {
    return []
  }
  if (!matchMethods.includes(matchMethod)) {
    matchMethod = 'exact'
  }
  if (!next) next = 1
  if (!size) size = 10

  condition = reduce(condition, (res: any, val: any, key) => {
    if (val != '') res[key] = val
    return res
  }, {})
  if (!keys(condition).length) {
    const begin = data.length < size ? 0 : size * (next - 1)
    const end = begin + size
    const result = data.slice(begin, end)
    return {
      data: result,
      total: data.length
    }
  }
  
  let result: any = []
  let total: number = 0
  result = data.reduce((res: any, obj: any) => {
    keys(condition).forEach((key: string) => {
      if (matchMethod == 'fuzzy') {
        const regexp = new RegExp('.*' + condition[key] + '.*')
        if (regexp.test(obj[key])) {
          // 去重
          if (!res.find((o: any) => o[key] == obj[key])) {
            res.push(obj)
          }
        }
      } else if (
        !res.find((o: any) => o[key] == obj[key])
        && condition[key] == obj[key]
      ) {
        res.push(obj)
      }
    })
    return res
  }, [])
  total = result.length
  const begin = total < size ? 0 : size * (next - 1)
  const end = begin + size
  result = result.slice(begin, end)
  
  return {
    data: result,
    total: total
  }
}
